var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SToolbar',[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("ic-20 ic-mediamanager ic-col-grey")]),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('media_manager')))])],1),_c('MainView',{attrs:{"session-key":"mm-main","height":"var(--usable-height)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }